
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sso_js",
      function () {
        return require("private-next-pages/sso_js.js");
      }
    ]);
  